import TooltipComponent from "../TooltipComponent";

type ButtonTooltipIconType = {
  title: string;
  icon: string;
  onClick: () => void;
  colorIcon?: "text-primary" | "text-secondary";
  isLink?: boolean;
  style?: any;
  withTitle?: boolean;
  disabled?: boolean;
  loading?: boolean;
  animation?: boolean;
};

export const ButtonTooltipIcon = ({
  title,
  icon,
  onClick,
  colorIcon = "text-secondary",
  isLink = true,
  style,
  withTitle = false,
  disabled = false,
  loading = false,
  animation
}: ButtonTooltipIconType) => {
  return withTitle ? (
    <div className="dropdown dropdown-intiza ">
      <button
        className={"btn dropdown-toggle p-0 "}
        type="button"
        disabled={disabled || loading}
      >
        <div
          onClick={onClick}
          className={"select-intiza select-intiza-primary"}
        >
          <span>
            {loading ? (
              <i className="fas fa-spinner-third fa-spin third me-2"></i>
            ) : (
              <i className={icon + " me-2"}></i>
            )}
            {title}
          </span>
        </div>
      </button>
    </div>
  ) : (
    <TooltipComponent title={title} animation={animation}>
      <button
        type="button"
        className={"btn button-outline-primary"}
        style={style}
        onClick={onClick}
        disabled={disabled || loading}
      >
        {loading ? (
          <i className="fas fa-spinner-third fa-spin third"></i>
        ) : (
          <i className={icon}></i>
        )}
      </button>
    </TooltipComponent>
  );
};
